import React, { useMemo } from 'react'
import { useState } from 'react'

import { TableCustom } from '../../../../../components/common'
import SubTasasModal from '../../../../../components/controls/SubTasasModal';
import { ALERT_TYPE, OPERATION_MODE, ShowToastMessage } from '@laramie/ui';
import { useEntidad } from '../../../../../components/hooks/useEntidad';
import { buildCellAVMR } from '../../../utils';

const Tasas = ({ tasas, setTasas, params }) => {
    const [adding, setAdding] = useState(false)
    const data = useMemo(() => tasas.filter(x => x.state !== 'r'), [tasas])

    const [entidadesLoaded, setEntidadesLoaded] = useState(false)
    const [, getEntidad] = useEntidad({
        entidades: ['Tasa', 'SubTasa'],
        onLoaded: (entidades, isSuccess, error) => {
          if (isSuccess) {
            setEntidadesLoaded(true)
          }
          else {
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
          }
        },
        memo: {
          key: 'Tasa_SubTasa',
          timeout: 0
        }
    })

    const labels = useMemo(() => {
        const result = { }
        data.forEach(tasa => {
            const entidadTasa = getEntidad('Tasa', tasa.idTasa)
            const entidadSubTasa = getEntidad('SubTasa', tasa.idSubTasa)
            if (entidadTasa && entidadSubTasa) result[tasa.id] = {
                tasa: `${entidadTasa.codigo} - ${entidadTasa.descripcion}`,
                subTasa: `${entidadSubTasa.codigo} - ${entidadSubTasa.descripcion}`
            }
        })
        return result
    }, [data, entidadesLoaded])

    const onAdd = () => {
        setAdding(true)
    }

    // las subtasas elegidas se agregan como una fila cada una; las que ya están en el
    // listado no se duplican, y si fueron dadas de baja en esta edición se reviven
    const onAddConfirm = (subTasas) => {
        const result = [...tasas]
        let agregadas = 0
        let repetidas = 0

        subTasas.forEach(subTasa => {
            const existente = result.findIndex(x => x.idSubTasa === subTasa.id)
            if (existente >= 0) {
                if (result[existente].state === 'r') {
                    const revivida = result[existente]
                    result[existente] = {...revivida, state: revivida.id < 0 ? 'a' : 'o'}
                    agregadas++
                }
                else {
                    repetidas++
                }
            }
            else {
                result.push({
                    id: -Date.now() - agregadas,
                    idPagoContadoDefinicion: parseInt(params.id),
                    idTasa: subTasa.idTasa,
                    idSubTasa: subTasa.id,
                    state: 'a',
                })
                agregadas++
            }
        })

        setAdding(false)

        if (agregadas === 0) {
            ShowToastMessage(ALERT_TYPE.ALERT_WARNING, 'Las sub tasas seleccionadas ya estaban en el listado')
            return
        }

        setTasas(result)

        if (repetidas > 0) {
            ShowToastMessage(ALERT_TYPE.ALERT_WARNING, `Se agregaron ${agregadas}; ${repetidas} ya estaban en el listado`)
        }
    }

    const onRemove = (tasa) => {
        setTasas(tasas.map(x => x.id === tasa.id ? {...x, state: 'r'} : x))
    }

    const tableColumns = [
        { Header: 'Tasa', Cell: ({ row }) => entidadesLoaded ? labels[row.original.id]?.tasa ?? '' : '', accessor: 'idTasa', width: '45%' },
        { Header: 'Sub tasa', Cell: ({ row }) => entidadesLoaded ? labels[row.original.id]?.subTasa ?? '' : '', accessor: 'idSubTasa', width: '45%' },
        buildCellAVMR({ onAdd, onRemove, readOnly: params.mode === OPERATION_MODE.VIEW })
    ]

    return (
        <div>
            <div className="col-12 m-top-15">
                <label className="form-label">Tasas</label>
            </div>

            <TableCustom
                floatingDownloadCSVButton={true}
                showFilterGlobal={false}
                className='TableCustomBase'
                columns={tableColumns}
                data={data}
            />

            {adding && (
                <SubTasasModal
                    multiple={true}
                    onDismiss={() => setAdding(false)}
                    onConfirmMultiple={onAddConfirm}
                />
            )}
        </div>
    )
}

export default Tasas
